import { useDispatch } from 'react-redux';

export const SelectionButtons = ({ type, options, selectedPoint, actionType }) => {
    const dispatch = useDispatch();
    const className = type === "rotation" ? "rotation-selection-container" : "torque-selection-container";

    return (
        <div className={className}>
            {options.map(({ label, name }) => (
                <button
                    key={label}
                    title={name}
                    onClick={() => dispatch({ type: actionType, payload: label })}
                    className={`torque-button ${type === 'rotation' && label === 'RotationRoot' ? 'rotationRoot' : ''} ${selectedPoint === label ? "select" : ""}`}
                >
                    <span className="torque-dot"></span>
                </button>
            ))}
        </div>
    );
};
